var ctCalendarViewModel,
	_currentDate = new Date(),
	_selectedDate = new Date(),
	_sortByTimeInASC = function() {},
	_sortByItemSortOrder = function() {},
	_sortAccumulatedTime = function() {};

(function($) {
 	$.fn.capitechCalendar = function(options) {
		var $calendarElm = $(this),
			$calendarMonthDetailsElm = $('.ct-calendar-month-details'),
			$calendarDayDetailsElm = $('.ct-calendar-day-details'),
			tmpCalendarItems = [];
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			// Set calendar days
			updateCalendarDayHeaders();
			// Set up view model
			ctCalendarViewModel = new calendarViewModel();
			$('*[data-ko-bind="ctCalendarModel"]').each(function(index, obj) {
				ko.applyBindings(ctCalendarViewModel, obj);
			});
			updateCalendarUI(new Date());
		}
		
		// Calendar related functions
		/*////////////////////////////////////////////////////////////*/
		function updateCalendarDayHeaders() {
			var firstDayDate = moment(new Date()).startOf('week'),
				tmpName = '',
				tmpShortName = '',
				$objHeaderElm = $('.ct-calendar-headings .ct-calendar-day');
			for (var i = 0; i < 7; i++) {
				tmpName = moment(new Date()).startOf('week').add(i, 'd').format('dddd');
				tmpShortName = moment(new Date()).startOf('week').add(i, 'd').format('ddd');
				$($objHeaderElm[i]).find('.visible-sm-inline').text(tmpShortName);
				$($objHeaderElm[i]).find('.visible-lg-inline').text(tmpName);
			}
		}
		
		function updateCalendarUI(selectedDate) {
			// Render new calendar with days
			ctCalendarViewModel.removeAllCalendarDays();
			calendarDaysWithItems = createCalendarData(selectedDate, []);
			ctCalendarViewModel.addCalendarDataToView(calendarDaysWithItems);
			
			getCalendarItems(selectedDate);
			getAccumulatedTimeByMonth(selectedDate);
		}
		
		function createCalendarData(selectedDate, timeStampsData) {
			var firstDateInCalendarView = moment(selectedDate).startOf('month').startOf('week');
			var lastDateInCalendarView = moment(selectedDate).endOf('month').endOf('week');
			var diffDays = moment(lastDateInCalendarView).diff(firstDateInCalendarView, 'days') + 1;
			var aDays = [];
			var tmpDate = '';
			var tmpDateSearchString = '';
			var aTmpTimeStamps = {};
			var monthNumber = 0;
			var shortMonthMarkup = '';
			var selectedMonthNumber = moment(selectedDate).format('M');
			var bCurrentMonth = false;

			for(i=0; i < diffDays; i++) {
				// Create date
				tmpDate = moment(firstDateInCalendarView).add(i, 'day');
				
				shortMonthMarkup = '';
				if (monthNumber !== tmpDate.format('M')) {
					monthNumber = tmpDate.format('M');
					if (monthNumber === selectedMonthNumber) {
						bCurrentMonth = true;
					} else {
						bCurrentMonth = false;
					}
				}
				
				tmpDateSearchString = tmpDate.format('YYYY-MM-DD');
				// Add all timestamps to day
				aTmpTimeStamps = jQuery.grep(timeStampsData, function(timeStamp) { return timeStamp.dateIn == tmpDateSearchString });
				// console.log(jQuery.grep(timeStampsData, function(timeStamp) { return timeStamp.dateIn == tmpDateSearchString }));
				// Add day to day array
				aDays.push({date:tmpDate, bCurrentMonth:bCurrentMonth, timeStamps: aTmpTimeStamps});
			}
			return aDays;
		}
		
		function changeMonth(bNext) {
			var monthOffset = -1,
				newDate;
			if (bNext) {
				monthOffset = 1;
			}
			
			newDate = moment(ctCalendarViewModel.selectedDate()).startOf('month').add(monthOffset, 'months').toDate();
			ctCalendarViewModel.selectedDate(newDate);
			updateCalendarUI(newDate);
		}
		
		// Content from API
		/*////////////////////////////////////////////////////////////*/
		// TODO: vurder om denne funksjonen skal utvides med ekstra arguments slik at den både kan brukes for måned og dag - se updateCalendarItemsForSelectedDay() 
		function getCalendarItems(selectedDate) {
			var self = this;
			var firstDateInCalendarView = moment(selectedDate).startOf('month').startOf('week');
			var lastDateInCalendarView = moment(selectedDate).endOf('month').endOf('week');
			var firstDutyDate = moment();
			self.aCalendarItemTypes = ['timeStamps','holliday'];
			
			// Show loader
			loaderIndicator(true);
			
			// Remove old tmpCalendarItems
			tmpCalendarItems = [];
			
			self.calendarItemsCallback = function() {
				self.aCalendarItemTypes.shift();
				if (self.aCalendarItemTypes.length == 0) {
					// Hide loader
					loaderIndicator(false);
					
					// Remove all days
					ctCalendarViewModel.removeAllCalendarDays();
					
					// Fill UI with data
					calendarDaysWithItems = createCalendarData(selectedDate, tmpCalendarItems);
					ctCalendarViewModel.addCalendarDataToView(calendarDaysWithItems);

					// Get user settings
					var userSettings = getLocalStorage('myCapitechUserSettings');
					
					if (userSettings && userSettings.selectCurrentDateOnStartup === "true") {
						$('.ct-calendar-today').trigger('click');
						userSettings.selectCurrentDateOnStartup = false;
						setLocalStorage('myCapitechUserSettings', userSettings);
					}
				}
			}
			
			getTimeTransactions(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
			getHolidays(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
			
			if (getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasAbsenceRegistration || getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasSimployerAbsence) {
				self.aCalendarItemTypes.push('absences');
				getAbsences(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
			}
			
			if (getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechPlan || getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechFlowPlan) {
				// Some duty types need to be displayed back in time
				self.aCalendarItemTypes.push('plannedDuties');
				self.aCalendarItemTypes.push('requestedDuties');
				self.aCalendarItemTypes.push('dutyWish');
				self.aCalendarItemTypes.push('dutyWishPeriods');
				getPlannedDutiesForEmployee(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
				getRequestedDuties(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
				getDutyWish(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
				getDutyWishPeriods(firstDateInCalendarView, lastDateInCalendarView, self.calendarItemsCallback);
				// We only want avaliableDuties that is today or in the future
				if (moment().diff(lastDateInCalendarView) <= 0) {
					
					if (moment().diff(firstDateInCalendarView) <= 0) {
						firstDutyDate = moment(selectedDate).startOf('week');
					}
					self.aCalendarItemTypes.push('avaliableDuties');
					getAvaliableDuties(firstDutyDate, lastDateInCalendarView, self.calendarItemsCallback);
				}
			}
		}
		
		function updateCalendarItemsForSelectedDay(selectedDate) {
			var self = this;
			var momentSelectedDate = moment(selectedDate);
			self.aCalendarItemTypes = ['timeStamps','holliday'];
			
			// Show loader
			loaderIndicator(true);
			
			getAccumulatedTimeByDay(selectedDate);
		
			// Remove old tmpCalendarItems
			tmpCalendarItems = [];
		
			self.calendarItemsCallback = function() {
				self.aCalendarItemTypes.shift();
				if (self.aCalendarItemTypes.length == 0) {
					// Hide loader
					loaderIndicator(false);
				
					// Update current day
					ctCalendarViewModel.daySelected().timeStamps.removeAll();
					$(tmpCalendarItems).each(function(index, obj) {
						ctCalendarViewModel.daySelected().timeStamps.push(new calendarDayItemModel(obj));
					});
					ctCalendarViewModel.daySelected().timeStamps.sort(_sortByItemSortOrder);
				}
			}
			
			getTimeTransactions(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
			getHolidays(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
			
			if (getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasAbsenceRegistration || getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasSimployerAbsence) {
				self.aCalendarItemTypes.push('absences');
				getAbsences(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
			}
			
			if (getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechPlan || getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechFlowPlan) {
				self.aCalendarItemTypes.push('plannedDuties');
				self.aCalendarItemTypes.push('requestedDuties');
				self.aCalendarItemTypes.push('dutyWish');
				self.aCalendarItemTypes.push('dutyWishPeriods');
				
				getPlannedDutiesForEmployee(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
				getRequestedDuties(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
				getDutyWish(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
				getDutyWishPeriods(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
				refreshEmployeeRegistrationInformation(momentSelectedDate);
				
				if (moment().diff(momentSelectedDate) <= 0) {
					self.aCalendarItemTypes.push('avaliableDuties');
					getAvaliableDuties(momentSelectedDate, momentSelectedDate, self.calendarItemsCallback);
				}
			}
		}
		
		function getTimeTransactions(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var timeTransactions = data.content;
				// add template info
				$.each(timeTransactions, function(index, val) {
					timeTransactions[index].template = 'timeTransaction';
					timeTransactions[index].description = timeTransactions[index].transactionDescriptions;
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(timeTransactions);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getTimeTransactionDetails_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getAbsences(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var absences = data.content;
				// add template info
				$.each(absences, function(index, val) {
					absences[index].template = 'absenceTransaction';
					absences[index].dateIn = absences[index].dateFrom;
					absences[index].timeIn = absences[index].timeFrom;
					absences[index].timeOut = absences[index].timeTo;
					absences[index].description = absences[index].absenceCodeDescription
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(absences);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			_api.getAbsenceTransactions_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getPlannedDutiesForEmployee(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var plannedDuties = data.content;
				// add template info
				$.each(plannedDuties, function(index, val) {
					plannedDuties[index].template = 'plannedDuties';
					plannedDuties[index].dateIn = plannedDuties[index].dutyStartDate;
					plannedDuties[index].timeIn = plannedDuties[index].dutyStartTime || '00:00';
					plannedDuties[index].timeOut = plannedDuties[index].dutyEndTime || '00:00';
					plannedDuties[index].description = plannedDuties[index].dutyTypeDescription;
					plannedDuties[index].departmentName = plannedDuties[index].departmentDescription;
					plannedDuties[index].dutyDefinitionId = plannedDuties[index].dutyDefinitionId ? plannedDuties[index].dutyDefinitionId : null;
					plannedDuties[index].fridim1Id = plannedDuties[index].freeDimension1Id ? plannedDuties[index].freeDimension1Id : null;
					plannedDuties[index].fridim2Id = plannedDuties[index].freeDimension2Id ? plannedDuties[index].freeDimension2Id : null;
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(plannedDuties);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getPlannedDutiesForEmployee_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getAvaliableDuties(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var avaliableDuties = data.content;
				// add template info
				$.each(avaliableDuties, function(index, val) {
					avaliableDuties[index].template = 'avaliableDuties';
					avaliableDuties[index].dateIn = avaliableDuties[index].startDate;
					avaliableDuties[index].timeIn = avaliableDuties[index].originalStartTime || '00:00';
					avaliableDuties[index].dateOut = avaliableDuties[index].endDate;
					avaliableDuties[index].timeOut = avaliableDuties[index].originalEndTime || '00:00';
					avaliableDuties[index].departmentName = avaliableDuties[index].departmentDescription;
					avaliableDuties[index].dutyIdString = avaliableDuties[index].dutyStrId;
					avaliableDuties[index].description = avaliableDuties[index].dutyTypeDescription;
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(avaliableDuties);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getAvaliableDuties_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getRequestedDuties(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var requestedDuties = data.content;
				// add template info
				$.each(requestedDuties, function(index, val) {
					requestedDuties[index].template = 'requestedDuties';
					requestedDuties[index].dateIn = requestedDuties[index].startDate;
					requestedDuties[index].timeIn = requestedDuties[index].originalStartTime || '00:00';
					requestedDuties[index].dateOut = requestedDuties[index].endDate;
					requestedDuties[index].timeOut = requestedDuties[index].originalEndTime || '00:00';
					requestedDuties[index].description = requestedDuties[index].dutyTypeDescription;
					requestedDuties[index].departmentName = requestedDuties[index].departmentDescription;
					requestedDuties[index].comment = requestedDuties[index].employeeText;
					requestedDuties[index].dutyIdString = requestedDuties[index].dutyStrId;
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(requestedDuties);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getRequestedDuties_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getDutyWish(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var dutyWish = data.content;
				// add template info
				$.each(dutyWish, function(index, val) {
					dutyWish[index].template = 'dutyWish';
					dutyWish[index].dateIn = dutyWish[index].date;
					dutyWish[index].timeIn = '0002';
					dutyWish[index].dateOut = dutyWish[index].date;
					dutyWish[index].timeOut = '0002';
					dutyWish[index].dutyWishStartDate = dutyWish[index].date;
					dutyWish[index].dutyWishEndDate = dutyWish[index].date;
					dutyWish[index].description = getResource('app.dutyWishText');
					dutyWish[index].comment = dutyWish[index].commentFromEmployee;
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(dutyWish);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getDutyWish_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getDutyWishPeriods(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var dutyWishPeriodsTmp = data.content;
				var dutyWishPeriods = [];
				// add template info
				$.each(dutyWishPeriodsTmp, function(index, val) {
					var startDate = moment(dutyWishPeriodsTmp[index].fromDate);
					var endDate = moment(dutyWishPeriodsTmp[index].toDate);
					var dateDiff = endDate.diff(startDate, 'd') + 1;
					
					// If dates is equal, we are only refreshing current date.
					if (fromDate == toDate) {
						dateDiff = 1;
					}
					
					for (var i = 0; i < dateDiff; i++) {
						var dutyWishPeriodsItemTmp = {};
						var tmpDate = moment(startDate).add(i, 'd');
						var tmpIsoWeekday = tmpDate.isoWeekday();
						dutyWishPeriodsItemTmp.template = 'dutyWishPeriods';
						dutyWishPeriodsItemTmp.dateIn = tmpDate.format('YYYY-MM-DD');
						dutyWishPeriodsItemTmp.timeIn = '0001';
						dutyWishPeriodsItemTmp.dateOut = dutyWishPeriodsTmp[index].toDate;
						dutyWishPeriodsItemTmp.timeOut = '0001';
						dutyWishPeriodsItemTmp.dutyWishStartDate = dutyWishPeriodsTmp[index].fromDate;
						dutyWishPeriodsItemTmp.dutyWishEndDate = dutyWishPeriodsTmp[index].toDate;
						dutyWishPeriodsItemTmp.description = getResource('app.dutyWishPeriodsText');
						dutyWishPeriodsItemTmp.comment = dutyWishPeriodsTmp[index].commentFromEmployee;
						dutyWishPeriodsItemTmp.isEmployeeAvaliableOnShortNotice = dutyWishPeriodsTmp[index].commentFromEmployee;
						dutyWishPeriodsItemTmp.requestedDepartmentIds = dutyWishPeriodsTmp[index].requestedDepartmentIds;
						dutyWishPeriodsItemTmp.requestedDutyTypeIds = dutyWishPeriodsTmp[index].requestedDutyTypeIds;
						
						if (isInArray(tmpIsoWeekday, dutyWishPeriodsTmp[index].requestedDaysOfWeek)) {
							dutyWishPeriods.push(dutyWishPeriodsItemTmp);
						}
					}
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(dutyWishPeriods);

				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getDutyWishPeriods_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		function getHolidays(fromDate, toDate, callback) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			
			var success = function(data, textStatus, jqXHR) {
				var holidays = data.content;
				// add template info
				$.each(holidays, function(index, val) {
					holidays[index].template = 'holiday';
					holidays[index].dateIn = holidays[index].date;
					holidays[index].timeIn = '0000';
					holidays[index].timeOut = '0000';
					holidays[index].description = holidays[index].name;
				});
				// add timestamps to calendarItems
				tmpCalendarItems = tmpCalendarItems.concat(holidays);
				callback();
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				callback();
			}
			
			_api.getHolidays_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				fromDate.format('YYYY-MM-DD'),
				toDate.format('YYYY-MM-DD')
			);
		}
		
		// Timestamp form functions
		/*////////////////////////////////////////////////////////////*/
		function loadTimeStampFormData(templateTimeTransaction) {
			var self = this;
			self.registrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationRules;
			self.aDimensions = ['Department'];
			self.aDimensionsCopy = ['Department'];
			
			// Show loader
			loaderIndicator(true);
			
			// Build API call list
			$.each(self.registrationSetup, function(key, value) {
				if (value && key !== 'registrationCloseDate') {
					self.aDimensions.push(key.substring(8))
				}
			});
			
			dimensionCallback = function() {
				self.aDimensionsCopy.shift();
				if (self.aDimensionsCopy.length == 0) {
					// Hide loader
					loaderIndicator(false);
					
					if (templateTimeTransaction) {
						ctCalendarViewModel.selectedTimeTransactionClone(templateTimeTransaction);
					} else {
						ctCalendarViewModel.selectedTimeTransactionClone(new calendarDayItemModel(ko.toJS(ctCalendarViewModel.selectedTimeTransaction)));
					}
					showTimeStampForm();
				}
			}
			
			// Make a copy of the dimension array, so we dont destroy the main array
			self.aDimensionsCopy = self.aDimensions.slice();
			
			// Get all dimentions
			$.each(self.aDimensions, function(index, val) {
				try {
					var funcTemp = eval('get' + val);
					funcTemp(dimensionCallback, true);
				} catch (err) {
					dimensionCallback();
				}
				// console.log('loop: ' + val);
			});
		}
		
		function displayDimensionFormItems() {
			var registrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationRules;
			var dimensionNames = getLocalStorage('myCapitechDimensionNames');
			
			// add department to registrationSetup
			registrationSetup.registerDepartment = true;
			
			$.each(registrationSetup, function(key, bRequiredInStamp) {
				if(key.slice(0,8) === "register") { 
					var cleanedKey = key.slice(8);
					var keyHeadlessCamelCase = cleanedKey.substr(0, 1).toLowerCase() + cleanedKey.substr(1);
					var keyLowerCase = cleanedKey.toLowerCase();
					var $dimensionElm = $('.' + key);
					var bRequired = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationRequiredFields['is' + key.slice(8) + 'IdRequired'];
					var visibility = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationVisibilityRules[keyHeadlessCamelCase] ? getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationVisibilityRules[keyHeadlessCamelCase] : 1; // 1 Show, 2 Hidden, 3 ReadOnly
					var defaultValue = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults[keyHeadlessCamelCase + 'Id'];
					var $labelElm = $dimensionElm.find('label');
					var labelText = dimensionNames[keyLowerCase + 'Description'];
					
					// Use default text if dimensionNames is missing value
					if (!labelText) {
						labelText = $labelElm.text();
					}
					
					// Dimension should only be visible if:
					// Registration rules says it should be and visibility is 1 OR 3
					// Or if the field is required and no default value is provided
					if ((bRequiredInStamp && (visibility === 1 || visibility === 3)) || (bRequired && !defaultValue)) {
						$dimensionElm.css('display', 'block');
						if (bRequired) {
							$dimensionElm.find('select').prop('required', true);
							$labelElm.html(labelText + ' <span class="ct-color-red">*</span>');
						} else {
							$labelElm.text(labelText);
						}
					} else {
						$dimensionElm.css('display', 'none');
					}
				}
			});
		}
		
		function showTimeStampForm() {
			$.magnificPopup.open({
				mainClass: 'dialog-slide-bottom',
				closeOnBgClick: false,
				items: {
					src: $('#ct-edit-timestamp'),
					type: 'inline'
				},
				callbacks: {
					open: function() {
						var $thisElm = $(this.container[0]);
						var browserWidth = $(window).width();
						var refreshSelect2Elements = function() {
							$('#ct-edit-timestamp .form-group select').each(function(index, obj) {
								$obj = $(obj);
								if (obj.length >= 40 || browserWidth >= 1024) {
									$obj.addClass("is-select2");
									$obj.select2({
										theme: "bootstrap",
										templateResult: function(result, container) {
											if (!result.id) {
												return result.text;
											}
											$(container).addClass('needsclick');
											return result.text;
										}
									});
								} else {
									if ($obj.hasClass("is-select2")) {
										$obj.select2("destroy");
										$obj.removeClass("is-select2");
									}
								}
							});
							$('#ct-edit-timestamp .form-group').on('touchstart', function(event) {
								event.target.classList.add('needsclick');
							});
						}
						
						initializeComponents($thisElm);
						
						// Translate labels
						translateGUI($thisElm);
						
						// Use registration labels if exists
						displayDimensionFormItems();
						
						// add mask to time inputs
						$thisElm.find('input.ct-input-time').inputmask({'alias': 'capitechHourAndMinutes'});
						
						// Department change
						$thisElm.off('change', '#departmentId');
						$thisElm.on('change', '#departmentId', function(event) {
							getDuty(refreshSelect2Elements);
							getTask(refreshSelect2Elements);
						});
						
						// Project change
						$thisElm.off('change', '#projectId');
						$thisElm.on('change', '#projectId', function(event) {
							getSubProject(refreshSelect2Elements);
						});
						
						// Sub project change
						$thisElm.off('change', '#subProjectId');
						$thisElm.on('change', '#subProjectId', function(event) {
							getPhase(refreshSelect2Elements);
						});
						
						var $form = $thisElm.find("form");
						if ($form.attr("data-validator-bound") !== "true") {
							$.validator.messages.required = getResource('app.pleaseSelect');
							$form.attr("data-validator-bound", true);
							$form.validate({
								rules: {
									select: "required"
								},
								errorClass: "ct-color-red error",
								onsubmit: false
							});

							var $btn = $thisElm.find(".ct-btn-register");
							$btn.click(function() {
								if ($form.valid()) {
									$form.submit();
								}
							});
						}

						refreshSelect2Elements();
					},
					close: function() {
						// if (ctCalendarViewModel.selectedTimeTransaction().bNew()) {
						// 	ctCalendarViewModel.daySelected().timeStamps.remove(ctCalendarViewModel.selectedTimeTransaction());
						// }
						// ctCalendarViewModel.daySelected().timeStamps.sort(_sortByItemSortOrder);
						updateCalendarItemsForSelectedDay(ctCalendarViewModel.selectedTimeTransactionClone().dateIn());
					}
				}
			});
		}
		
		function getDepartment(callback, bInit) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			_api.getDepartmentDescriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getDepartment------');
					// console.log(data);
					ctCalendarViewModel.addDepartments(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			)
		}

		function getDutyDefinition(callback, bInit) {
			var currentDepartmentId;
			callback = typeof callback !== 'undefined' ? callback : function(){};
			bInit = typeof bInit !== 'undefined' ? bInit : false;
			
			_api.getDutyDefinitionDescriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getDutyDefinition------');
					// console.log(data);
					ctCalendarViewModel.addDutyDefinitions(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			);
		}

		function getCompetenceRole(callback, bInit) {
			var currentDepartmentId;
			callback = typeof callback !== 'undefined' ? callback : function(){};
			bInit = typeof bInit !== 'undefined' ? bInit : false;
			
			_api.getCompetenceroleDescriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getCompetenceRole------');
					// console.log(data);
					ctCalendarViewModel.addCompetenceRoles(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			);
		}
		
		function getTask(callback, bInit) {
			var currentDepartmentId;
			callback = typeof callback !== 'undefined' ? callback : function(){};
			bInit = typeof bInit !== 'undefined' ? bInit : false;
			
			if (bInit) {
				currentDepartmentId = ctCalendarViewModel.selectedTimeTransaction().departmentId();
			} else {
				currentDepartmentId = ctCalendarViewModel.selectedTimeTransactionClone().departmentId();
			}
			
			if (currentDepartmentId) {
				_api.getTaskDescriptions_POST(
					function(data, textStatus, jqXHR) {
						// console.log('------getDuty------');
						// console.log(data);
						ctCalendarViewModel.addTasks(data.content);
						callback();
					},
					function(jqXHR, textStatus, errorThrown) {
						sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
						callback();
					},
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					currentDepartmentId
				)
			} else {
				callback();
			}
		}
		
		function getDuty(callback, bInit) {
			var currentDepartmentId;
			callback = typeof callback !== 'undefined' ? callback : function(){};
			bInit = typeof bInit !== 'undefined' ? bInit : false;
			
			if (bInit) {
				currentDepartmentId = ctCalendarViewModel.selectedTimeTransaction().departmentId();
			} else {
				currentDepartmentId = ctCalendarViewModel.selectedTimeTransactionClone().departmentId();
			}
			
			if (currentDepartmentId) {
				_api.getDutyDescriptions_POST(
					function(data, textStatus, jqXHR) {
						// console.log('------getDuty------');
						// console.log(data);
						ctCalendarViewModel.addDutys(data.content);
						callback();
					},
					function(jqXHR, textStatus, errorThrown) {
						sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
						callback();
					},
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					currentDepartmentId
				)
			} else {
				callback();
			}
		}
		
		function getShift(callback, bInit) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			_api.getShiftDescriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getShift------');
					// console.log(data);
					ctCalendarViewModel.addShifts(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			)
		}
		
		function getOrder(callback, bInit) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			_api.getOrderDescriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getOrder------');
					// console.log(data);
					ctCalendarViewModel.addOrders(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			)
		}
		
		function getProject(callback, bInit) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			_api.getProjectDescriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getProject------');
					// console.log(data);
					ctCalendarViewModel.addProjects(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			)
		}
		
		function getSubProject(callback, bInit) {
			var currentProjectId;
			callback = typeof callback !== 'undefined' ? callback : function(){};
			bInit = typeof bInit !== 'undefined' ? bInit : false;
			
			if (bInit) {
				currentProjectId = ctCalendarViewModel.selectedTimeTransaction().projectId();
			} else {
				currentProjectId = ctCalendarViewModel.selectedTimeTransactionClone().projectId();
			}
			
			if (currentProjectId) {
				_api.getSubProjectDescriptions_POST(
					function(data, textStatus, jqXHR) {
						// console.log('------getSubProject------');
						// console.log(data);
						ctCalendarViewModel.addSubProjects(data.content);
						callback();
					},
					function(jqXHR, textStatus, errorThrown) {
						sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
						callback();
					},
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					currentProjectId
				);
			} else {
				callback();
			}
		}
		
		function getPhase(callback, bInit) {
			var projectId;
			var subProjectId;
			callback = typeof callback !== 'undefined' ? callback : function(){};
			bInit = typeof bInit !== 'undefined' ? bInit : false;
			
			if (bInit) {
				projectId = ctCalendarViewModel.selectedTimeTransaction().projectId();
				subProjectId = ctCalendarViewModel.selectedTimeTransaction().subProjectId();
			} else {
				projectId = ctCalendarViewModel.selectedTimeTransactionClone().projectId();
				subProjectId = ctCalendarViewModel.selectedTimeTransactionClone().subProjectId();
			}
			
			if (projectId && subProjectId) {
				_api.getPhaseDescriptions_POST(
					function(data, textStatus, jqXHR) {
						// console.log('------getPhase------');
						// console.log(data);
						ctCalendarViewModel.addPhases(data.content);
						callback();
					},
					function(jqXHR, textStatus, errorThrown) {
						sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
						callback();
					},
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					projectId,
					subProjectId
				);
			} else {
				callback();
			}
		}
		
		function getFridim1(callback, bInit) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			_api.getFridim1Descriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getFridim1------');
					// console.log(data);
					ctCalendarViewModel.addFridim1s(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			)
		}
		
		function getFridim2(callback, bInit) {
			callback = typeof callback !== 'undefined' ? callback : function(){};
			_api.getFridim2Descriptions_POST(
				function(data, textStatus, jqXHR) {
					// console.log('------getFridim2------');
					// console.log(data);
					ctCalendarViewModel.addFridim2s(data.content);
					callback();
				},
				function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					callback();
				},
				getCookie(ACCESSTOKEN_COOKIE_NAME)
			)
		}
		
		function upsertTimeTransactionToDB() {
			var timeDataForm = ko.toJS(ctCalendarViewModel.selectedTimeTransactionClone());
			var timeDataSelected = ko.toJS(ctCalendarViewModel.selectedTimeTransaction());
			var newDateOut = moment(timeDataForm.dateIn);
			
			var success = function(data, textStatus, jqXHR) {
				if (data.success === true) {
					// Update the copy
					ctCalendarViewModel.selectedTimeTransactionClone().description(data.content[0].transactionDescriptions);
					
					// Update the selected item
					ctCalendarViewModel.selectedTimeTransaction().dateIn(ctCalendarViewModel.selectedTimeTransactionClone().dateIn());
					ctCalendarViewModel.selectedTimeTransaction().timeIn(ctCalendarViewModel.selectedTimeTransactionClone().timeIn());
					ctCalendarViewModel.selectedTimeTransaction().dateOut(ctCalendarViewModel.selectedTimeTransactionClone().dateOut());
					ctCalendarViewModel.selectedTimeTransaction().timeOut(ctCalendarViewModel.selectedTimeTransactionClone().timeOut());
					ctCalendarViewModel.selectedTimeTransaction().departmentId(ctCalendarViewModel.selectedTimeTransactionClone().departmentId());
					ctCalendarViewModel.selectedTimeTransaction().dutyDefinitionId(ctCalendarViewModel.selectedTimeTransactionClone().dutyDefinitionId());
					ctCalendarViewModel.selectedTimeTransaction().competenceRoleId(ctCalendarViewModel.selectedTimeTransactionClone().competenceRoleId());
					ctCalendarViewModel.selectedTimeTransaction().taskId(ctCalendarViewModel.selectedTimeTransactionClone().taskId());
					ctCalendarViewModel.selectedTimeTransaction().orderId(ctCalendarViewModel.selectedTimeTransactionClone().orderId());
					ctCalendarViewModel.selectedTimeTransaction().projectId(ctCalendarViewModel.selectedTimeTransactionClone().projectId());
					ctCalendarViewModel.selectedTimeTransaction().subProjectId(ctCalendarViewModel.selectedTimeTransactionClone().subProjectId());
					ctCalendarViewModel.selectedTimeTransaction().phaseId(ctCalendarViewModel.selectedTimeTransactionClone().phaseId());
					ctCalendarViewModel.selectedTimeTransaction().dutyId(ctCalendarViewModel.selectedTimeTransactionClone().dutyId());
					ctCalendarViewModel.selectedTimeTransaction().shiftId(ctCalendarViewModel.selectedTimeTransactionClone().shiftId());
					ctCalendarViewModel.selectedTimeTransaction().fridim1Id(ctCalendarViewModel.selectedTimeTransactionClone().fridim1Id());
					ctCalendarViewModel.selectedTimeTransaction().fridim2Id(ctCalendarViewModel.selectedTimeTransactionClone().fridim2Id());
					ctCalendarViewModel.selectedTimeTransaction().comment(ctCalendarViewModel.selectedTimeTransactionClone().comment());
					ctCalendarViewModel.selectedTimeTransaction().description(ctCalendarViewModel.selectedTimeTransactionClone().description());
					ctCalendarViewModel.selectedTimeTransaction().bNew(false);
					
					getAccumulatedTimeByMonth(ctCalendarViewModel.selectedDate());
					
					$.magnificPopup.close();
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				};
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
			}
			
			// Validate data timeOut
			if (!timeDataForm.timeOut || timeDataForm.timeOut.length < 5) {
				timeDataForm.dateOut = "";
				newDateOut = "";
			} else {
				if (timeDataForm.timeIn > timeDataForm.timeOut) {
					newDateOut = newDateOut.add(1,'days').format('YYYY-MM-DD');
					timeDataForm.dateOut = newDateOut;
				}
			}

			if (timeDataForm.bNew) {
				_api.createCustomTimeTransaction_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					timeDataForm.dateIn,
					timeDataForm.timeIn,
					timeDataForm.dateOut,
					timeDataForm.timeOut,
					timeDataForm.departmentId,
					timeDataForm.taskId,
					timeDataForm.orderId,
					timeDataForm.projectId,
					timeDataForm.subProjectId,
					timeDataForm.phaseId,
					timeDataForm.dutyId,
					timeDataForm.competenceRoleId,
					timeDataForm.dutyDefinitionId,
					timeDataForm.shiftId,
					timeDataForm.fridim1Id,
					timeDataForm.fridim2Id,
					timeDataForm.comment
				);
			} else {
				_api.updateTimeTransaction_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					timeDataSelected.dateIn,
					timeDataSelected.timeIn,
					timeDataForm.dateIn,
					timeDataForm.timeIn,
					timeDataForm.dateOut,
					timeDataForm.timeOut,
					timeDataForm.departmentId,
					timeDataForm.taskId,
					timeDataForm.orderId,
					timeDataForm.projectId,
					timeDataForm.subProjectId,
					timeDataForm.phaseId,
					timeDataForm.dutyId,
					timeDataForm.competenceRoleId,
					timeDataForm.dutyDefinitionId,
					timeDataForm.shiftId,
					timeDataForm.fridim1Id,
					timeDataForm.fridim2Id,
					timeDataForm.comment
				);
			}
		}
			
		function deleteTimeTransaction() {
			var timeDataSelected = ko.toJS(ctCalendarViewModel.selectedTimeTransaction());
			var success = function(data, textStatus, jqXHR) {
				if (data.success === true) {
					// Delete the selected item
					updateCalendarItemsForSelectedDay(ctCalendarViewModel.selectedTimeTransaction().dateIn());
					ctCalendarViewModel.daySelected().timeStamps.remove(ctCalendarViewModel.selectedTimeTransaction());
					getAccumulatedTimeByMonth(ctCalendarViewModel.selectedDate());
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				};
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.informationTitle'), textStatus, "error");
			}
			
			_api.deleteTimeTransaction_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				timeDataSelected.dateIn,
				timeDataSelected.timeIn
			);
		}
		
		// Accumulated time related functions
		/*////////////////////////////////////////////////////////////*/
		function getAccumulatedTimeByMonth(date) {
			var fromDate = moment(date).startOf('month');
			var toDate = moment(date).endOf('month');
			var success = function(data, textStatus, jqXHR) {
				ctCalendarViewModel.removeAllAccumulatedTimeByMonth();
				ctCalendarViewModel.addAccumulatedTimeByMonth(data.content);
				ctCalendarViewModel.aAccumulatedTimeByMonth.sort(_sortAccumulatedTime);
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
			}
			_api.getAccumulatedTime_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'));
		}
		
		function getAccumulatedTimeByDay(date) {
			var success = function(data, textStatus, jqXHR) {
				ctCalendarViewModel.removeAllAccumulatedTimeByDay();
				ctCalendarViewModel.addAccumulatedTimeByDay(data.content);
				ctCalendarViewModel.aAccumulatedTimeByDay.sort(_sortAccumulatedTime);
			}
			var error = function(jqXHR, textStatus, errorThrown) {
				sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
			}
			_api.getAccumulatedTime_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), moment(date).format('YYYY-MM-DD'), moment(date).format('YYYY-MM-DD'));
		}

		function refreshEmployeeRegistrationInformation(forDate) {
			var success = function success(data, textStatus, jqXHR) {
				if (data.success == true && data.content.length === 1) {
					var registrationSetup = data.content[0];
					setLocalStorage('myCapitechPermissionsAndRegistrationSetup', registrationSetup);
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				// sweetAlert("Error", errorThrown, "error");
			};
			_api.getEmployeeRegistrationInformation_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), moment(forDate).format('YYYY-MM-DD'));
		}
		
		// Duty related functions
		/*////////////////////////////////////////////////////////////*/
		function showDutyWishForm() {
			$.magnificPopup.open({
				mainClass: 'dialog-slide-bottom',
				closeOnBgClick: false,
				key:'testtest',
				items: {
					src: $('#ct-create-dutywish'),
					type: 'inline'
				},
				callbacks: {
					open: function() {
						var $thisElm = $(this.container[0]);
						initializeComponents($thisElm);
						
						// Translate labels
						translateGUI($thisElm);
						
						// Reset form
						resetDutyWishForm();
					}
				}
			});
		}
		
		function resetDutyWishForm() {
			var $dutyWishDateFrom = $('#dutyWishDateFrom');
			var $dutyWishDateTo = $('#dutyWishDateTo');
			var dutyWishDateFrom = moment($dutyWishDateFrom.val());
			var dutyWishDateTo = moment($dutyWishDateTo.val());

			if (dutyWishDateFrom.diff(dutyWishDateTo) !== 0) {
				$('.ct-checkbox-group-wrapper').removeClass('col-md-6').addClass('col-md-4');
				$('.ct-checkbox-days').show(0);
			} else {
				$('.ct-checkbox-days').hide(0);
				$('.ct-checkbox-group-wrapper').removeClass('col-md-4').addClass('col-md-6');
			}
		}
		
		$('#ct-create-dutywish').on('change', '#dutyWishDateFrom, #dutyWishDateTo', function(e) {
			resetDutyWishForm();
		});
		
		function showRequestDutyForm() {
			$.magnificPopup.open({
				mainClass: 'dialog-slide-bottom',
				closeOnBgClick: false,
				items: {
					src: $('#ct-request-duty'),
					type: 'inline'
				},
				callbacks: {
					open: function() {
						var $thisElm = $(this.container[0]);
						initializeComponents($thisElm);
						
						// Translate labels
						translateGUI($thisElm);
					},
					close: function() {
						if (ctCalendarViewModel.selectedTimeTransaction().bNew()) {
							ctCalendarViewModel.daySelected().timeStamps.remove(ctCalendarViewModel.selectedTimeTransaction());
						}
						ctCalendarViewModel.daySelected().timeStamps.sort(_sortByItemSortOrder);
					}
				}
			});
		}
		
		// Manual addition
		/*////////////////////////////////////////////////////////////*/
		function openManualAddition() {
			$.magnificPopup.open({
				mainClass: 'dialog-slide-bottom',
				closeOnBgClick: false,
				items: {
					src: $('#ct-manual-addition'),
					type: 'inline'
				},
				callbacks: {
					open: function() {
						var $thisElm = $(this.container[0]);
						initializeComponents($thisElm);
						
						// Translate labels
						translateGUI($thisElm);
					},
					close: function() {
						updateCalendarItemsForSelectedDay(ctCalendarViewModel.daySelected().date().format('YYYY-MM-DD'));
					}
				}
			});
		}
		
		// View models
		/*////////////////////////////////////////////////////////////*/
		var calendarWeekModel = function(date) {
			// properties
			var self = this;
			self.date = ko.observable(date);
			self.template = 'weekNumberTemplate';
		};

		var calendarDayModel = function(date, bCurrentMonth, timeStamps) {
			// properties
			var self = this;
			self.date = ko.observable(date);
			self.timeStamps = ko.observableArray(timeStamps);
			self.timeStamps.sort(_sortByItemSortOrder);
			self.bCurrentMonth = bCurrentMonth;
			self.dayOfMonth = ko.computed(function() {
				return parseInt(moment(self.date()).format('D'));
			}, self);
			self.monthName = ko.computed(function() {
				return moment(self.date()).format('MMMM');
			}, self);
			self.shortMonthName = ko.computed(function() {
				if (self.dayOfMonth() === 1 || (self.bCurrentMonth === false && self.dayOfMonth() == moment(self.date()).endOf('month').format('D'))) {
					return '. ' + moment(self.date()).format('MMM');
				} else {
					return ''
				}
			}, self);
			self.template = 'dayTemplate';
			self.bCanEditBackInTime = ko.computed(function() {
				var bShow = false;
				var now;
				var dayDiff;
				var secondsDiff;
				var registrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup');
				
				try {
					secondsDiff = ctCalendarViewModel.now().diff(moment(self.date()), 'seconds');
					dayDiff = moment(ctCalendarViewModel.now()).startOf('day').diff(moment(self.date()), 'day', true);
					
					// IF canRegisterAtAll IS true
					// AND secondsDiff IS GTE -7205 (Added 5 seconds to to hours, so the user GUI is updated when the time is 22:00)
					// AND dayDiff LTE numberOfDaysBackInTimeRegisteringIsAllowed
					// AND canRegisterAtAll IS true
					// THEN the user will have permission to register hours on the selected date.
					if (
						registrationSetup.canRegisterAtAll && (
							(secondsDiff >= -7205 && dayDiff <= registrationSetup.numberOfDaysBackInTimeRegisteringIsAllowed && registrationSetup.canRegisterBackInTime === true)
						)
					) {
						bShow = true;
					}
				} catch (err) {
					// console.log(err);
				}
				return bShow;
			}, self);
			self.bCanEditForwardsInTime = ko.computed(function() {
				var bShow = false;
				var dayDiff;
				var secondsDiff;
				var registrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup');
				
				try {
					secondsDiff = moment(self.date()).diff(ctCalendarViewModel.now(), 'seconds');
					dayDiff = moment(self.date()).startOf('day').diff(ctCalendarViewModel.now(), 'day', true);
					
					// IF canRegisterAtAll IS true
					// AND canRegisterForwardInTime IS TRUE
					// AND secondsDiff IS GTE 7205 (Added 5 seconds to to hours, so the user GUI is updated when the time is 22:00)
					// AND dayDiff LTE numberOfDaysForwardInTimeRegisteringIsAllowed
					// THEN the user will have permission to register hours on the selected date.
					if (
						registrationSetup.canRegisterAtAll && registrationSetup.canRegisterForwardInTime === true && (
							(secondsDiff >= 7205 && dayDiff <= registrationSetup.numberOfDaysForwardInTimeRegisteringIsAllowed)
						)
					) {
						bShow = true;
					}
				} catch (err) {
					// console.log(err);
				}
				return bShow;
			}, self);
			
			self.bCanRegisterInOut = ko.computed(function() {
				var bShow = false;
				var registrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup');
				var userSettings = getLocalStorage('myCapitechUserSettings');
				if (userSettings && userSettings.deactivateTimeInAndOutButtons && userSettings.deactivateTimeInAndOutButtons === "true") {
					return false;
				}
				try {
					var now = getMomentDateTimeNow();
					var diff = moment.duration(moment(now.format("YYYY-MM-DD")).diff(moment(self.date())));
					var dayDiff = diff.asDays();
					if (
						registrationSetup.canRegisterAtAll && (
							(dayDiff === 0 && registrationSetup.canRegisterBackInTime === false || (dayDiff >= 0 && dayDiff <= registrationSetup.numberOfDaysBackInTimeRegisteringIsAllowed && registrationSetup.canRegisterBackInTime === true))
							// ||
							// (dayDiff === 0 && registrationSetup.canRegisterForwardInTime === false || (dayDiff >= 0 && dayDiff <= registrationSetup.numberOfDaysForwardInTimeRegisteringIsAllowed && registrationSetup.canRegisterForwardInTime === true))
						)
					) {
						bShow = true;
					}
				} catch (err) {
				}
				return bShow;
			});
			self.bTodayOrFuture = ko.computed(function() {
				var bReturn = false;
				var now = getMomentDateTimeNow();
				try {
					var diff = now.diff(self.date(), 'days', false);
					if (diff <= 0) {
						bReturn = true;
					}
				} catch (err) {
				}
				return bReturn;
			});
			self.bToday = ko.computed(function() {
				var now = getMomentDateTimeNow();
				var diff = moment.duration(moment(self.date()).diff(now.format("YYYY-MM-DD")));
				var dayDiff = diff.asDays();
				var bShow = false;
				if (dayDiff == 0) {
					bShow = true;
				}
				return bShow;
			});
			self.bYesterday = ko.computed(function() {
				var now = getMomentDateTimeNow();
				var diff = moment.duration(moment(self.date()).diff(now.format("YYYY-MM-DD")));
				var dayDiff = diff.asDays();
				var bShow = false;
				if (dayDiff == -1) {
					bShow = true;
				}
				return bShow;
			});
			self.bValidateRequiredFieldsHasValue = ko.computed(function() {
				var bValidateRequiredFieldsHasValue = true;
				var registrationRules = loweCaseObjectKeys(getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationRules);
				var registrationDefaults = loweCaseObjectKeys(getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults);
				var registrationRequiredFields = loweCaseObjectKeys(getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationRequiredFields);
				
				if (self.bToday()) {
					// add department to registrationSetup
					registrationRules.registerDepartment = true;
			
					$.each(registrationRules, function(key, value) {
						var keyLowerCase = key.slice(8).toLowerCase();
						var bRequired = registrationRequiredFields['is' + key.slice(8) + 'idrequired'];
						var keyValue = registrationDefaults[keyLowerCase + 'id'];
						
						if (bRequired) {
							if (keyValue == null) {
								// If this condition occurs set false and break out of each loop.
								bValidateRequiredFieldsHasValue = false;
								return false;
							}
						}
					
					});
				} else {
					bValidateRequiredFieldsHasValue = false;
				}
				return bValidateRequiredFieldsHasValue;
			});
			self.bDisplayStampOut = ko.computed(function() {
				var bDisplayStampOut = false;

				var userSettings = getLocalStorage('myCapitechUserSettings');
				if (userSettings && userSettings.deactivateTimeInAndOutButtons && userSettings.deactivateTimeInAndOutButtons === "true") {
					return false;
				}
				
				if ((self.bToday() || self.bYesterday()) && self.timeStamps().length > 0) {
					$(self.timeStamps()).each(function(index, obj) {
						if (obj.template() === 'timeTransaction' || obj.template() === 'timeTransactionMissingTimeOut') {
							if (obj.timeOut()) {
								bDisplayStampOut = false;
							} else {
								bDisplayStampOut = true;
							}
						}
					});
				}
				return bDisplayStampOut;
			}, self);
			
			// functions
			self.deleteTimeTransaction = function(timeStamp) {
				self.timeStamps.remove(timeStamp);
			};
			self.clickAddTimeTransactionAction = function(day) {
				self.newTimeTransaction(day);
			}
			self.newTimeTransaction = function(day) {
				var timeIn = moment(new Date()).format('HH:mm');
				var tempTimeIn;
				var timeStamp;
				if (day.bToday() === false && day.bTodayOrFuture() === true && day.timeStamps().length === 0) {
					timeIn = "00:00"
				} else if (day.timeStamps().length > 0) {
					for (var i = 0; i < day.timeStamps().length; i++) {
						var tempObj = day.timeStamps()[i];
						if ((tempObj.template() == 'timeTransaction' || tempObj.template() == 'timeTransactionMissingTimeOut') && typeof tempObj.timeOut() !== 'undefined') {
							tempTimeIn = tempObj.timeOut();
						}
					}
					if (typeof tempTimeIn !== 'undefined' && tempTimeIn !== null && tempTimeIn.length === 5) {
						timeIn = tempTimeIn;
					}
				}
				timeStamp = new calendarDayItemModel({dateIn: moment(day.date()).format('YYYY-MM-DD'), timeIn: timeIn, bNew: true});
				ctCalendarViewModel.selectedTimeTransaction(timeStamp);
				self.timeStamps.push(timeStamp);
				loadTimeStampFormData();
			}
			self.clickAddDutyWishAction = function(day) {
				var timeStamp = new calendarDayItemModel({dateIn: moment(day.date()).format('YYYY-MM-DD'), bNew: true});
				ctCalendarViewModel.selectedTimeTransaction(timeStamp);
				self.timeStamps.push(timeStamp);
				loadTimeStampFormData();
			}
			self.displayDayDutyWishFormClickAction = function() {
				showDutyWishForm();
			}
			
			self.createDefaultTimeTransactionIn = function(day) {
				var success = function(data, textStatus, jqXHR) {
					loaderIndicator(false);
					if (data.success === true) {
						updateCalendarItemsForSelectedDay(ctCalendarViewModel.daySelected().date().format('YYYY-MM-DD'));
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
						self.clickAddTimeTransactionAction(day);
					};
				}
				var error = function(jqXHR, textStatus, errorThrown) {
					loaderIndicator(false);
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				}
				loaderIndicator(true);
				_api.createDefaultTimeTransactionIn_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME)
				);
			}
			
			self.createTimeTransactionOut = function() {
				var success = function(data, textStatus, jqXHR) {
					loaderIndicator(false);
					if (data.success === true) {
						updateCalendarItemsForSelectedDay(ctCalendarViewModel.daySelected().date().format('YYYY-MM-DD'));
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					};
				}
				var error = function(jqXHR, textStatus, errorThrown) {
					loaderIndicator(false);
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				}
				loaderIndicator(true);
				_api.createTimeTransactionOut_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME)
				);
			}
			
			self.pageNavigateToAbsence = function() {
				var currentDate = self.date().format("YYYY-MM-DD");
				window.location.href = 'absence.htm?v={gulp-my-capitech-version}&selectedDate=' + currentDate + '#absence';
			}
			
			
		};
		
		var calendarDayItemModel = function(properties) {
			if(typeof(properties)==='undefined')											properties										=		{};
			if(typeof(properties.clientId)==='undefined')									properties.clientId								=		getCookie(CLIENTID_COOKIE_NAME);
			if(typeof(properties.comment)==='undefined')									properties.comment								=		'';
			if(typeof(properties.notes)==='undefined' || properties.notes === null)			properties.notes								=		'';
			if(typeof(properties.dateIn)==='undefined')										properties.dateIn								=		moment(new Date()).format('YYYY-MM-DD');
			if(typeof(properties.dateOut)==='undefined' || properties.dateOut === null)		properties.dateOut								=		properties.dateIn;
			if(typeof(properties.departmentId)==='undefined')								properties.departmentId							=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.departmentId;
			if(typeof(properties.dutyId)==='undefined')										properties.dutyId								=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.dutyId;
			if(typeof(properties.fridim1Id)==='undefined')									properties.fridim1Id							=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.fridim1Id;
			if(typeof(properties.fridim2Id)==='undefined')									properties.fridim2Id							=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.fridim2Id;
			if(typeof(properties.orderId)==='undefined')									properties.orderId								=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.orderId;
			if(typeof(properties.originIn)==='undefined')									properties.originIn								=		'';
			if(typeof(properties.originOut)==='undefined')									properties.originOut							=		'';
			if(typeof(properties.originalTimeIn)==='undefined')								properties.originalTimeIn						=		'';
			if(typeof(properties.originalTimeOut)==='undefined')							properties.originalTimeOut						=		'';
			if(typeof(properties.periodPlanId)==='undefined')								properties.periodPlanId							=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.periodPlanId;
			if(typeof(properties.phaseId)==='undefined')									properties.phaseId								=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.phaseId;
			if(typeof(properties.projectId)==='undefined')									properties.projectId							=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.projectId;
			if(typeof(properties.shiftId)==='undefined')									properties.shiftId								=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.shiftId;
			if(typeof(properties.subProjectId)==='undefined')								properties.subProjectId							=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.subProjectId;
			if(typeof(properties.taskId)==='undefined')										properties.taskId								=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.taskId;
			// Flow plan properties
			if(typeof(properties.dutyDefinitionId)==='undefined')							properties.dutyDefinitionId						=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.dutyDefinitionId;
			if(typeof(properties.competenceRoleId)==='undefined')							properties.competenceRoleId						=		getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.competenceRoleId;

			if(typeof(properties.timeIn)==='undefined')										properties.timeIn								=		moment(new Date()).format('HH:mm');
			if(typeof(properties.timeOut)==='undefined')									properties.timeOut								=		'';
			if(typeof(properties.template)==='undefined')									properties.template								=		'timeTransaction';
			if(typeof(properties.bNew)==='undefined')										properties.bNew									=		false;
			// description is a custom property that both absence and planned duty uses
			if(typeof(properties.description)==='undefined')								properties.description							=		'';
			// this is planned duty specific properties
			if(typeof(properties.departmentName)==='undefined')								properties.departmentName						=		'';
			if(typeof(properties.dutyIdString)==='undefined')								properties.dutyIdString							=		'';
			if(typeof(properties.dutyPlanId)==='undefined')									properties.dutyPlanId							=		'';
			// this is duty wish (day and period) specific properties
			if(typeof(properties.dutyWishStartDate)==='undefined')							properties.dutyWishStartDate					=		'';
			if(typeof(properties.dutyWishEndDate)==='undefined')							properties.dutyWishEndDate						=		'';
			if(typeof(properties.requestedDepartmentIds)==='undefined')						properties.requestedDepartmentIds				=		[];
			if(typeof(properties.requestedDutyTypeIds)==='undefined')						properties.requestedDutyTypeIds					=		[];
			if(typeof(properties.isEmployeeAvaliableOnShortNotice)==='undefined')			properties.isEmployeeAvaliableOnShortNotice		=		false;

			if(typeof(properties.dutyDescriptions)==='undefined')							properties.dutyDescriptions						=		'';

			// this is requested duty specific properties
			if(typeof(properties.startDate)==='undefined')									properties.startDate							=		'';
			
			var self = this;
			self.clientId							= ko.observable(properties.clientId);
			self.comment							= ko.observable(properties.comment);
			self.notes								= ko.observable(properties.notes);
			self.dateIn								= ko.observable(properties.dateIn);
			self.dateOut							= ko.observable(properties.dateOut);
			self.departmentId						= ko.observable(properties.departmentId); // getLocalStorage('myCapitechPermissionsAndRegistrationSetup').registrationDefaults.departmentId
			self.dutyId								= ko.observable(properties.dutyId);
			self.employeeGroupId					= ko.observable(properties.employeeGroupId);
			self.employeeId							= ko.observable(properties.employeeId);
			self.fridim1Id							= ko.observable(properties.fridim1Id);
			self.fridim2Id							= ko.observable(properties.fridim2Id);
			self.orderId							= ko.observable(properties.orderId);
			self.originIn							= ko.observable(properties.originIn);
			self.originOut							= ko.observable(properties.originOut);
			self.originalTimeIn						= ko.observable(properties.originalTimeIn);
			self.originalTimeOut					= ko.observable(properties.originalTimeOut);
			self.periodPlanId						= ko.observable(properties.periodPlanId);
			self.phaseId							= ko.observable(properties.phaseId);
			self.projectId							= ko.observable(properties.projectId);
			self.shiftId							= ko.observable(properties.shiftId);
			self.subProjectId						= ko.observable(properties.subProjectId);
			self.systemDate							= ko.observable(properties.systemDate);
			self.systemTime							= ko.observable(properties.systemTime);
			self.taskId								= ko.observable(properties.taskId);
			self.timeIn								= ko.observable(properties.timeIn);
			self.timeOut							= ko.observable(properties.timeOut);
			self.template							= ko.observable(properties.template);
			self.bNew								= ko.observable(properties.bNew);
			// description is a custom property that both absence and planned duty uses
			self.description						= ko.observable(properties.description);
			// this is planned duty specific properties
			self.departmentName						= ko.observable(properties.departmentName);
			self.dutyIdString						= ko.observable(properties.dutyIdString);
			self.dutyPlanId							= ko.observable(properties.dutyPlanId);
			// Flow plan properties
			self.dutyDefinitionId					= ko.observable(properties.dutyDefinitionId);
			self.competenceRoleId					= ko.observable(properties.competenceRoleId);
			// this is duty wish specific properties
			self.dutyWishStartDate					= ko.observable(properties.dutyWishStartDate);
			self.dutyWishEndDate					= ko.observable(properties.dutyWishEndDate);
			self.requestedDepartmentIds				= ko.observable(properties.requestedDepartmentIds);
			self.requestedDutyTypeIds				= ko.observable(properties.requestedDutyTypeIds);
			self.isEmployeeAvaliableOnShortNotice	= ko.observable(properties.isEmployeeAvaliableOnShortNotice);
			self.dutyDescriptions					= ko.observable(properties.dutyDescriptions);

			// this is requested duty specific properties
			self.startDate							= ko.observable(properties.startDate);

			self.itemSortOrder					= ko.observable(1000);
			if (self.template() === 'absenceTransaction') {
				self.itemSortOrder(0);
			} else if (self.template() === 'plannedDuties') {
				self.itemSortOrder(1);
			} else if (self.template() === 'timeTransaction') {
				self.itemSortOrder(2);
			} else if (self.template() === 'requestedDuties') {
				self.itemSortOrder(4);
			} else if (self.template() === 'dutyWish') {
				self.itemSortOrder(5);
			} else if (self.template() === 'dutyWishPeriods') {
				self.itemSortOrder(6);
			} else if (self.template() === 'avaliableDuties') {
				self.itemSortOrder(7);
			}

			// time transaction missing out should use own template
			self.dynamicTemplateSwitcher = ko.computed(function() {
				var bSwitched = false;
				if (self.template() == "timeTransaction" && !self.timeOut()) {
					self.template('timeTransactionMissingTimeOut');
					bSwitched = true;
				}
				if (self.template() == "timeTransactionMissingTimeOut" && self.timeOut()) {
					self.template('timeTransaction');
					bSwitched = true;
				}
				return bSwitched;
			}, self);
			
			self.editTimeStampClickAction = function(timeStamp) {
				ctCalendarViewModel.selectedTimeTransaction(timeStamp);
				loadTimeStampFormData();
			};
			self.deleteTimeTransactionClickAction = function(timeStamp) {
				ctCalendarViewModel.selectedTimeTransaction(timeStamp);
				sweetAlert({
					title: getResource('app.confirmDeletionTitle'),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: getResource('app.delete'),
					cancelButtonText: getResource('app.cancel')
				},function() {
					deleteTimeTransaction();
				});
			}
			self.viewTimeStampClickAction = function(timeTransaction) {
				var markup = '';
				var date = moment(timeTransaction.dateIn()).format('LL');
				var time = '';
				var timeOut = timeTransaction.timeOut();
			
				var success = function(data, textStatus, jqXHR) {
					loaderIndicator(false);
					
					ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.removeAll();
					if (data.content.length > 0) {
						$(data.content).each(function(index, obj) {
							ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.push(new accumulatedTimeModel(obj));
						});
						ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.sort(_sortAccumulatedTime);
					}
					
					if (timeTransaction.bCanDoManualAddition()) {
						ctCalendarViewModel.timeCategoryForManualAddition.removeAll();
						$(getLocalStorage('myCapitechTimeCategoryForManualAddition')).each(function(index,obj) {
							ctCalendarViewModel.timeCategoryForManualAddition.push(new timeCategoryForManualAdditionModel(obj));
						});
						ctCalendarViewModel.timeCategoryForManualAddition.sort(_sortAccumulatedTime);
						
						ctCalendarViewModel.selectedTimeTransaction(timeTransaction);
						openManualAddition();
					} else {
						if (timeTransaction.timeIn() !== timeTransaction.timeOut()) {
							if (!timeTransaction.timeOut()) {
								timeOut = 'XX:XX';
							}
							time = ', ' + timeTransaction.timeIn() + ' - ' + timeOut;
						}
			
						markup = '<p>' + date + time + '</p>' +
								 '<p><strong>' + getResource('app.informationText') + '</strong><br>' +
								 timeTransaction.description() + '</p>';
			
						if (timeTransaction.comment().length > 0) {
							markup = markup +
									 '<p><strong>' + getResource('dimension.commentLabel') + '</strong><br>' +
									 timeTransaction.comment() + '</p>';
						}
					
						if (ctCalendarViewModel.selectedTimeTransactionAccumulatedTime().length > 0) {
							markup = markup + '<p><strong>' + getResource('app.hoursAndExtraRates') + '</strong><br>';
							$(ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()).each(function(index, obj) {
								markup = markup + obj.timeCategoryDescription() + ': ' + obj.amount().toFixed(2) + '<br>'
							});
							markup = markup + '</p>';
						}
						sweetAlert({title: getResource('timestamp.detailedTitle'), text: markup, html: true});
					}
				}
			
				var error = function(jqXHR, textStatus, errorThrown) {
					loaderIndicator(false);
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				}
			
				loaderIndicator(true);
				_api.getAccumulatedTimeForSingleTransaction_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					timeTransaction.dateIn(),
					timeTransaction.timeIn()
				);
			}
			self.viewDutyClickAction = function(duty) {
				var markup = '';
				var date = moment(duty.dateIn()).format('LL');
				var time = '';
				var resourceKey = 'app.detailsTitle';
			
				if (duty.template() == 'plannedDuties') {
					resourceKey = 'plannedDuty.detailedTitle';
				}
				if (duty.template() == 'requestedDuties') {
					resourceKey = 'app.typenameRequestedDuty';
				}
				if (duty.template() == 'avaliableDuties') {
					resourceKey = 'app.typenameAvailableDuty';
				}
				if (duty.timeIn() !== duty.timeOut()) {
					time = ', ' + duty.timeIn() + ' - ' + duty.timeOut();
				}
				
				markup = '<p>' + date + time + '</p>' +
							'<p><strong>' + getResource('app.informationText') + '</strong></p>';
				if (duty.dutyDescriptions().length) {
					markup = markup + '<p>' + duty.dutyDescriptions() + '</p>';
				} else {
					markup = markup + '<p><strong>' + getResource('app.departmentText') + '</strong>: ' + duty.departmentId() + ' - ' + duty.departmentName() + '</p>'; +
							'<p><strong>' + getResource('app.dutyText') + '</strong>: ' + duty.dutyIdString() + ', ' + duty.description() + '</p>';
				}
			
				if (duty.dutyPlanId() != '') {
					markup = markup +  '<p><strong>' + getResource('app.planNumberText') + '</strong>: ' + duty.dutyPlanId() + '</p>';
				}
				if (duty.comment() != '') {
					markup = markup +  '<p><strong>' + getResource('app.noticeText') + '</strong>: ' + duty.comment() + '</p>';
				}
				if (duty.notes() != '') {
					markup = markup +  '<p><strong>' + getResource('app.notes') + '</strong>: ' + duty.notes() + '</p>';
				}
				sweetAlert({title: getResource(resourceKey), text: markup, html: true});
			}
			self.viewDutyWishClickAction = function(dutyWish) {
				var markup = '';
				var date = moment(dutyWish.dateIn()).format('LL');
				var time = '';
				var departments = getLocalStorage('myCapitechDutyWishFilterValues').departments;
				var dutyTypes = getLocalStorage('myCapitechDutyWishFilterValues').dutyTypes;
				var departmentNames = [];
				var dutyTypesNames = [];
				var tmpDepartmentObj = {};
				var tmpDepartmentName;
				var tmpDutyObj = {};
				var tmpDutyName;
				
				if (moment(dutyWish.dutyWishStartDate()).diff(moment(dutyWish.dutyWishEndDate()),'d') !== 0) {
					date = moment(dutyWish.dutyWishStartDate()).format('LL') + ' - ' + moment(dutyWish.dutyWishEndDate()).format('LL');
				}
				
				for (i = 0; i < dutyWish.requestedDepartmentIds().length; ++i) {
					tmpDepartmentObj = findObjectInArray(departments, 'id', dutyWish.requestedDepartmentIds()[i]);
					tmpDepartmentName = tmpDepartmentObj.id + '-' + tmpDepartmentObj.description;
					departmentNames.push(tmpDepartmentName);
				}
				
				for (i = 0; i < dutyWish.requestedDutyTypeIds().length; ++i) {
					tmpDutyObj = findObjectInArray(dutyTypes, 'id', dutyWish.requestedDutyTypeIds()[i]);
					tmpDutyName = tmpDutyObj.description;
					dutyTypesNames.push(tmpDutyName);
				}
				
				markup = '<p>' + date + time + '</p>';
				if (dutyWish.isEmployeeAvaliableOnShortNotice()) {
					markup = markup + '<p><strong>' + getResource('duty.shortNotice') + '</strong></p>';
				}
				markup = markup + '<p><strong>' + getResource('app.informationText') + '</strong></p>' +
						 '<p><strong>' + getResource('app.departmentText') + '</strong>: ' + departmentNames.join(', ') + '</p>' +
						 '<p><strong>' + getResource('app.dutyText') + '</strong>: ' + dutyTypesNames.join(', ') + '</p>';
				if (dutyWish.comment() != '') {
					markup = markup + '<p><strong>' + getResource('app.noticeText') + '</strong>: ' + dutyWish.comment() + '</p>';
				}
				
				markup = '<div style="max-height:230px;overflow:auto;border-bottom:solid 1px #ccc">' + markup + '</div>'
				
				sweetAlert({title: getResource('app.typenameDutyWish'), text: markup, html: true});
			}
			self.viewAbsenceClickAction = function(timeStamp) {
				var markup = '';
				var date = moment(timeStamp.dateIn()).format('LL');
				var time = '';
				
				if (timeStamp.timeIn() !== timeStamp.timeOut()) {
					time = ', ' + timeStamp.timeIn() + ' - ' + timeStamp.timeOut();
				}
				
				markup = '<p>' + date + time + '</p>' +
						 '<p><strong>' + getResource('app.informationText') + '</strong></p>' +
						 '<p>' + timeStamp.description() + '</p>';
				
				sweetAlert({title: getResource('absence.detailedTitle'), text: markup, html: true});
			}
			self.viewRequestAvaliableDutyForm = function(avaliableDuty) {
				ctCalendarViewModel.selectedAvaliableDuty(new calendarDayItemModel(ko.toJS(avaliableDuty)));
				showRequestDutyForm(avaliableDuty);
			}
			self.deleteRequestedDutyClickAction = function(requestedDuty) {
				sweetAlert({
					title: getResource('app.confirmDeletionTitle'),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: getResource('app.delete'),
					cancelButtonText: getResource('app.cancel')
				},function() {
					var success = function(data, textStatus, jqXHR) {
						updateCalendarItemsForSelectedDay(ctCalendarViewModel.daySelected().date().format('YYYY-MM-DD'));
					}
					var error = function(jqXHR, textStatus, errorThrown) {
						sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					}
					_api.cancelRequestForAvaliableDuty_POST(
						success,
						error,
						getCookie(ACCESSTOKEN_COOKIE_NAME),
						requestedDuty.departmentId(),
						requestedDuty.dutyPlanId(),
						requestedDuty.dutyId(),
						requestedDuty.startDate()
					);
				});
			}
			self.deleteDutyWishClickAction = function(dutyWish) {
				var dateDiff = moment(dutyWish.dutyWishStartDate()).diff(moment(dutyWish.dutyWishEndDate()),'d');
				var tmpDutyWishStartDate = dutyWish.dutyWishStartDate();
				
				sweetAlert({
					title: getResource('app.confirmDeletionTitle'),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: getResource('app.delete'),
					cancelButtonText: getResource('app.cancel')
				},function() {
					var success = function(data, textStatus, jqXHR) {
						if (dateDiff === 0) {
							ctCalendarViewModel.daySelected().timeStamps.remove(dutyWish);
						} else {
							$(ctCalendarViewModel.days()).each(function(index,obj) {
								$(obj.timeStamps()).each(function(childIndex, childObj) {
									if(childObj.template() === 'dutyWishPeriods') {
										if (childObj.dutyWishStartDate() === tmpDutyWishStartDate) {
											obj.timeStamps.remove(childObj);
										}
									}
								});
							});
						}
					}
					var error = function(jqXHR, textStatus, errorThrown) {
						sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
					}
					
					if (dateDiff === 0) {
						_api.deleteDutyWish_POST(
							success,
							error,
							getCookie(ACCESSTOKEN_COOKIE_NAME),
							dutyWish.dutyWishStartDate()
						);
					} else {
						_api.deleteDutyWishPeriod_POST(
							success,
							error,
							getCookie(ACCESSTOKEN_COOKIE_NAME),
							dutyWish.dutyWishStartDate()
						);
					}
				});
			}
			self.quickRegisterTime = function(day, requestedDuty, event) {
				// Set some default props
				var timeStampProps = {};
				timeStampProps.dateIn = requestedDuty.dateIn();
				timeStampProps.dateOut = requestedDuty.dateOut();
				timeStampProps.timeIn = requestedDuty.timeIn();
				timeStampProps.timeOut = requestedDuty.timeOut();
				timeStampProps.bNew = true;

				// Create knockout timeTransaction
				var timeStamp = new calendarDayItemModel(timeStampProps);
				timeStamp.competenceRoleId(requestedDuty.competenceRoleId());
				timeStamp.departmentId(requestedDuty.departmentId());

				if (!getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechFlowPlan) {
					// If system uses the old Plan we need to set dutyId, and ignore dutyDefinitionId.
					timeStamp.dutyId(requestedDuty.dutyId());
				} else {
					// If system uses Capitech Flow Plan we need to set dutyDefinitionId, and ignore dutyId property because this only points at the uid for the duty in flow plan
					timeStamp.dutyDefinitionId(requestedDuty.dutyDefinitionId() ? requestedDuty.dutyDefinitionId() : undefined);
				}
				timeStamp.fridim1Id(requestedDuty.fridim1Id());
				timeStamp.fridim2Id(requestedDuty.fridim2Id());
				timeStamp.orderId(requestedDuty.orderId());
				timeStamp.phaseId(requestedDuty.phaseId());
				timeStamp.projectId(requestedDuty.projectId());
				timeStamp.subProjectId(requestedDuty.subProjectId());
				timeStamp.taskId(requestedDuty.taskId());

				var onErrorCallback = function() {
					// Update registration defaults to the planned duty settings..
					var currentEmployeeRegistrationInformation = getLocalStorage("myCapitechPermissionsAndRegistrationSetup");
					currentEmployeeRegistrationInformation.registrationDefaults.competenceRoleId = timeStamp.competenceRoleId();
					currentEmployeeRegistrationInformation.registrationDefaults.departmentId = timeStamp.departmentId();
					currentEmployeeRegistrationInformation.registrationDefaults.dutyDefinitionId = timeStamp.dutyDefinitionId();
					currentEmployeeRegistrationInformation.registrationDefaults.dutyId = timeStamp.dutyId();
					currentEmployeeRegistrationInformation.registrationDefaults.fridim1Id = timeStamp.fridim1Id();
					currentEmployeeRegistrationInformation.registrationDefaults.fridim2Id = timeStamp.fridim2Id();
					currentEmployeeRegistrationInformation.registrationDefaults.orderId = timeStamp.orderId();
					currentEmployeeRegistrationInformation.registrationDefaults.phaseId = timeStamp.phaseId();
					currentEmployeeRegistrationInformation.registrationDefaults.projectId = timeStamp.projectId();
					currentEmployeeRegistrationInformation.registrationDefaults.shiftId = timeStamp.shiftId();
					currentEmployeeRegistrationInformation.registrationDefaults.subProjectId = timeStamp.subProjectId();
					currentEmployeeRegistrationInformation.registrationDefaults.taskId = timeStamp.taskId();
					setLocalStorage("myCapitechPermissionsAndRegistrationSetup", currentEmployeeRegistrationInformation);
					loadTimeStampFormData(timeStamp);
				}

				var error = function(data) {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					onErrorCallback();
				}

				var success = function(data) {
					if (data.success) {
						updateCalendarItemsForSelectedDay(timeStamp.dateIn());
						getAccumulatedTimeByMonth(ctCalendarViewModel.selectedDate());
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
						onErrorCallback();
					}
				}

				function returnUndefinedIfFalsy(thisString) {
					return thisString ? thisString : undefined;
				}

				// Validate data timeOut
				if (timeStamp.timeIn() > timeStamp.timeOut()) {
					var newDateOut = moment(timeStamp.dateOut()).add(1,'days').format('YYYY-MM-DD');
					timeStamp.dateOut(newDateOut);
				}
	
				_api.createCustomTimeTransaction_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					returnUndefinedIfFalsy(timeStamp.dateIn()),
					returnUndefinedIfFalsy(timeStamp.timeIn()),
					returnUndefinedIfFalsy(timeStamp.dateOut()),
					returnUndefinedIfFalsy(timeStamp.timeOut()),
					returnUndefinedIfFalsy(timeStamp.departmentId()),
					returnUndefinedIfFalsy(timeStamp.taskId()),
					returnUndefinedIfFalsy(timeStamp.orderId()),
					returnUndefinedIfFalsy(timeStamp.projectId()),
					returnUndefinedIfFalsy(timeStamp.subProjectId()),
					returnUndefinedIfFalsy(timeStamp.phaseId()),
					returnUndefinedIfFalsy(timeStamp.dutyId()),
					returnUndefinedIfFalsy(timeStamp.competenceRoleId()),
					returnUndefinedIfFalsy(timeStamp.dutyDefinitionId()),
					returnUndefinedIfFalsy(timeStamp.shiftId()),
					returnUndefinedIfFalsy(timeStamp.fridim1Id()),
					returnUndefinedIfFalsy(timeStamp.fridim2Id()),
					returnUndefinedIfFalsy(timeStamp.comment())
				);
			}
			
			self.bCanDoManualAddition = ko.computed(function() {
				try {
					if (self.timeOut().length === 5 && getLocalStorage('myCapitechPermissionsAndRegistrationSetup').canDoManualAddition && ctCalendarViewModel.daySelected().bCanEditBackInTime()) {
						return true;
					} else {
						return false;
					}
				} catch (err) {
					return false;
				}
			});
		};
		
		var dimensionSelectDataModel = function(description, value) {
			// properties
			var self = this;
			self.description = ko.observable(description);
			self.value = ko.observable(value);
		};
		
		var accumulatedTimeModel = function(properties) {
			if(typeof(properties)==='undefined')							properties							=	{};
			if(typeof(properties.amount)==='undefined')						properties.amount					=	0;
			if(typeof(properties.isManualAdjustment)==='undefined')			properties.isManualAdjustment		=	false;
			if(typeof(properties.timeCategoryDescription)==='undefined')	properties.timeCategoryDescription	=	'';
			if(typeof(properties.timeCategoryId)==='undefined')				properties.timeCategoryId			=	null;
			
			var self = this;
			self.amount							= ko.observable(properties.amount);
			self.isManualAdjustment				= ko.observable(properties.isManualAdjustment);
			self.timeCategoryDescription		= ko.observable(properties.timeCategoryDescription);
			self.timeCategoryId					= ko.observable(properties.timeCategoryId);
			self.isDisabled						= ko.observable(true)
			self.fixedAmount = ko.computed(function() {
				return self.amount().toFixed(2);
			}, self);
			
			self.buttonText = ko.computed(function(accumulatedTime) {
				var buttonText = 'test';
				
				if (self.isDisabled() === true) {
					return getResource('app.btnEdit');
				} else {
					return getResource('app.btnSave');
				}
			}, self);
			
			self.onKeyPress = function (data, event) {
				try {
					if (event.which == 13) {
						self.editExistingAccumulatedTime(data);
						return false;
					}
					return true;
				} catch (e) {}
			}
			
			self.editExistingAccumulatedTime = function(accumulatedTime, event) {
				var target = (event.currentTarget) ? event.currentTarget : event.srcElement;
				var $amountInput = $(target).parents('tr').find('input');
				
				if (accumulatedTime.isDisabled() === true) {
					$(ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()).each(function(index, obj) {
						var latest = ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()[index].amount._latestValue;
						ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()[index].amount(0);
						ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()[index].amount(latest);
						ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()[index].isDisabled(true);
					});
					accumulatedTime.isDisabled(false);
					$amountInput.focus().select();
				} else {
					_api.updateManualAddition_POST(
						function(data){
							if (data.success === true) {
								ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.removeAll();
								if (data.content.length > 0) {
									$(data.content).each(function(index, obj) {
										ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.push(new accumulatedTimeModel(obj));
									});
									ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.sort(_sortAccumulatedTime);
								}
								accumulatedTime.isDisabled(true);
								getAccumulatedTimeByMonth(ctCalendarViewModel.selectedDate());
								getAccumulatedTimeByDay(ctCalendarViewModel.daySelected().date());
							} else {
								sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
							};	
						},
						function(){}, // error
						getCookie(ACCESSTOKEN_COOKIE_NAME),
						ctCalendarViewModel.selectedTimeTransaction().dateIn(),
						ctCalendarViewModel.selectedTimeTransaction().timeIn(),
						[
							{
								"originalTimeCategoryId": accumulatedTime.timeCategoryId,
								"newTimeCategoryId": accumulatedTime.timeCategoryId,
								"amount": $amountInput.val().replace(',', '.')
							}
						]
					);
				}
				
			}
		}
		
		var timeCategoryForManualAdditionModel = function(properties) {
			if(typeof(properties)==='undefined')							properties							=	{};
			if(typeof(properties.timeCategoryDescription)==='undefined')	properties.timeCategoryDescription	=	'';
			if(typeof(properties.timeCategoryId)==='undefined')				properties.timeCategoryId			=	null;
			
			var self = this;
			self.timeCategoryDescription	= ko.observable(properties.timeCategoryDescription);
			self.timeCategoryId				= ko.observable(properties.timeCategoryId);
			self.isVisible					= ko.computed(function() {
				var objFound = findObjectInArray(ko.toJS(ctCalendarViewModel.selectedTimeTransactionAccumulatedTime()), 'timeCategoryId', self.timeCategoryId());
				if(typeof(objFound)==='undefined') {
					return true;
				} else {
					return false;
				}
			}, self);
			self.onKeyPress = function (data, event) {
				try {
					if (event.which == 13) {
						self.addTimeCategoryToAccumulatedTime(data);
						return false;
					}
					return true;
				} catch (e) {}
			}
			self.addTimeCategoryToAccumulatedTime = function(timeCategory, event) {
				var target = (event.currentTarget) ? event.currentTarget : event.srcElement;
				var $amountInput = $(target).parents('tr').find('input');
				_api.updateManualAddition_POST(
					function(data){
						if (data.success === true) {
							ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.removeAll();
							if (data.content.length > 0) {
								$(data.content).each(function(index, obj) {
									ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.push(new accumulatedTimeModel(obj));
								});
								ctCalendarViewModel.selectedTimeTransactionAccumulatedTime.sort(_sortAccumulatedTime);
							}
							getAccumulatedTimeByMonth(ctCalendarViewModel.selectedDate());
							getAccumulatedTimeByDay(ctCalendarViewModel.daySelected().date());
						} else {
							sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
						};
					},
					function(){}, // error
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					ctCalendarViewModel.selectedTimeTransaction().dateIn(),
					ctCalendarViewModel.selectedTimeTransaction().timeIn(),
					[
						{
							"originalTimeCategoryId": null,
							"newTimeCategoryId": timeCategory.timeCategoryId,
							"amount": $amountInput.val().replace(',', '.')
						}
					]
				);
			}
		}
		
		var calendarViewModel = function(daysData) {
			var self = this;
			
			// Calendar controllers
			self.bShowTime = ko.observable(true);
			self.bShowPlannedDuty = ko.observable(true);
			self.bShowAbsence = ko.observable(true);
			self.bShowAvaliableDuty = ko.observable(true);
			
			// If filter is empty, set bShowAvaliableDuty to false
			if (getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechPlan || getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasCapitechFlowPlan) {
				if (getLocalStorage('myCapitechDutyWishFilter').departmentIds.length === 1 && getLocalStorage('myCapitechDutyWishFilter').departmentIds[0] === -1)  {
					self.bShowAvaliableDuty = ko.observable(false);
				}
			}
			
			// Calendar rules
			self.registrationCloseDate = moment(_currentDate).subtract(getLocalStorage('myCapitechPermissionsAndRegistrationSetup').numberOfDaysBackInTimeRegisteringIsAllowed, 'day');
			self.registrationCloseDateText = getResource('calendar.registrationCloseDateTextFirstPart') + ' ' +
											 moment(self.registrationCloseDate).format('LL') + ' ' +
											 getResource('calendar.registrationCloseDateTextLastPart');

			self.registrationForwardsCloseDate = moment(_currentDate).add(getLocalStorage('myCapitechPermissionsAndRegistrationSetup').numberOfDaysForwardInTimeRegisteringIsAllowed, 'day');
			
			if(getLocalStorage('myCapitechPermissionsAndRegistrationSetup').canRegisterForwardInTime) {
				self.registrationForwardsCloseDateText = getResource('calendar.registrationClosedForwardsFirstPart') + ' ' +
											 			 moment(self.registrationForwardsCloseDate).format('LL') + ' ' +
											 			 getResource('calendar.registrationCloseDateTextLastPart');
			} else {
				self.registrationForwardsCloseDateText = getResource('calendar.registrationForwardsNotAllowed');
			}

			// Calendar dates
			self.currentDate = ko.observable(_currentDate);
			self.currentYear = ko.computed(function() {
				return moment(self.currentDate()).format('YYYY');
			}, self);
			self.selectedDate = ko.observable(_selectedDate);
			self.selectedMonth = ko.computed(function() {
				return moment(self.selectedDate()).format('MMMM');
			}, self);
			self.selectedYear = ko.computed(function() {
				return moment(self.selectedDate()).format('YYYY');
			}, self);
			
			self.daySelected = ko.observable(new calendarDayModel());
			
			self.now = ko.observable(moment());
			// Update now every 10 seconds
			setInterval(function () {
				var aDayIsSelected = $('.ct-calendar-today.selected').length === 1;
				var loadedDate = moment(_currentDate);
				var selectedDate = moment(self.selectedDate());
				var now = moment();
				
				// The now() property in the VM need to be delayed to work properly with the UI logic and the property need to be greater than the setInterval repetition delay
				self.now(moment().subtract(3, 's'));
				
				// If any days are selected in calendar, and loaded date EQ selectedDate, and now has a diff to loadedDate EQ 1
				if (aDayIsSelected && loadedDate.diff(selectedDate, "days") === 0 && now.startOf('day').diff(loadedDate.startOf('day'), "days") === 1) {
					_currentDate = new Date();
					self.currentDate(_currentDate);
					
					sweetAlert({
						title: '',
						text: getResource("calendar.currentDayHasChanged", "Midnight has passed, do you want to go to today's date?"),
						showCancelButton: true,
						confirmButtonText: getResource('app.yes', 'Yes'),
						cancelButtonText: getResource('app.no', 'No')
					}, function(isConfirm) {
						if(isConfirm) {
							setTimeout(function () {
								self.now(moment());
								$('.ct-calendar-today').trigger('click');
							}, 250);
						}
					});
				}
			}, 1000); // Need to be less than the offset in self.now(moment().subtract(2, 's'))
			
			// Calendar arrays
			self.days = ko.observableArray();
			self.aWeek = ko.observableArray();
			self.aAccumulatedTimeByMonth = ko.observableArray();
			self.accumulatedTimeTotalByMonth = ko.computed(function() {
				var total = 0;
				ko.utils.arrayForEach(self.aAccumulatedTimeByMonth(), function(accumulatedTime) {
					total += parseFloat(accumulatedTime.amount());
				});
				return total.toFixed(2);
			}, self);
			self.aAccumulatedTimeByDay = ko.observableArray();
			self.accumulatedTimeTotalByDay = ko.computed(function() {
				var total = 0;
				ko.utils.arrayForEach(self.aAccumulatedTimeByDay(), function(accumulatedTime) {
					total += parseFloat(accumulatedTime.amount());
				});
				return total.toFixed(2);
			}, self);
			
			// Calendar temp
			self.selectedTimeTransaction = ko.observable(new calendarDayItemModel());
			self.selectedTimeTransactionClone = ko.observable(new calendarDayItemModel());
			self.selectedTimeTransactionAccumulatedTime = ko.observableArray();
			self.selectedAvaliableDuty = ko.observable(new calendarDayItemModel());
			
			self.timeCategoryForManualAddition = ko.observableArray();
			self.hasVisibleTimeCategoryForManualAddition = ko.computed(function() {
				var objFound = findObjectInArray(ko.toJS(self.timeCategoryForManualAddition()), 'isVisible', true);
				if(typeof(objFound)==='undefined') {
					return false;
				} else {
					return true;
				}
			}, self);
			
			// Template related functions
			self.getCalendarDayItemTemplate = function(timeStamp) {
				return timeStamp.template();
			};
			
			self.getDetailedCalendarDayItemTemplate = function(timeStamp) {
				return timeStamp.template() + 'Detailed';
			};
			
			self.getWeekItemTemplate = function(weekItem) {
				return weekItem.template;
			};
			
			// Add data
			self.addCalendarDataToView = function(daysData) {
				$.each(daysData, function(dayIndex, dayObjValue) {
					$.each(dayObjValue, function(dayObjKeyName, dayObjKeyValue) {
						if (dayObjKeyName == 'timeStamps') {
							var aTempTimeStamps = [];
							$.each(dayObjKeyValue, function(a, b) {
								aTempTimeStamps.push(new calendarDayItemModel(b));
							});
							self.days.push(new calendarDayModel(dayObjValue.date, dayObjValue.bCurrentMonth, aTempTimeStamps));
							// // console.log(dayObjValue.dayName);
						}
					});
				});
				self.addWeeks();
			};
			
			// Add data
			self.addWeeks = function() {
				var row = null,
					aRows = [],
					colCount = 7,
					days = self.days();
				
				self.aWeek.removeAll();
				
				for (var i = 0, j = days.length; i < j; i++) {
					//create a new row
					if (!row) {
						row = [];
						aRows.push(row);
						// Add week number
						row.push(new calendarWeekModel(days[i].date()));
					}
					row.push(days[i]);
					//start a new row
					if (i % colCount === colCount - 1) {
						row = null;
					}
				}
				
				$.each(aRows, function(index, val) {
					// console.log(val);
					self.aWeek.push(val);
				});
			};
			
			self.addAccumulatedTimeByMonth = function(accumulatedTimeData) {
				$.each(accumulatedTimeData, function(index, obj) {
					self.aAccumulatedTimeByMonth.push(new accumulatedTimeModel(obj));
				});
			};
			self.addAccumulatedTimeByDay = function(accumulatedTimeData) {
				$.each(accumulatedTimeData, function(index, obj) {
					self.aAccumulatedTimeByDay.push(new accumulatedTimeModel(obj));
				});
			};
			
			// Calendar timestamp dimensions
			self.aDepartment = ko.observableArray();
			self.addDepartments = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aDepartment.removeAll();
				self.aDepartment.push.apply(self.aDepartment, newItems);
			};

			self.aDutyDefinition = ko.observableArray();
			self.addDutyDefinitions = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aDutyDefinition.removeAll();
				self.aDutyDefinition.push.apply(self.aDutyDefinition, newItems);
			};
			
			self.aCompetenceRole = ko.observableArray();
			self.addCompetenceRoles = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aCompetenceRole.removeAll();
				self.aCompetenceRole.push.apply(self.aCompetenceRole, newItems);
			};
			
			self.aDuty = ko.observableArray();
			self.addDutys = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aDuty.removeAll();
				self.aDuty.push.apply(self.aDuty, newItems);
			};
			
			self.aTask = ko.observableArray();
			self.addTasks = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aTask.removeAll();
				self.aTask.push.apply(self.aTask, newItems);
			};
			
			self.aShift = ko.observableArray();
			self.addShifts = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aShift.removeAll();
				self.aShift.push.apply(self.aShift, newItems);
			};
			
			self.aOrder = ko.observableArray();
			self.addOrders = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aOrder.removeAll();
				self.aOrder.push.apply(self.aOrder, newItems);
			};
			
			self.aProject = ko.observableArray();
			self.addProjects = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aProject.removeAll();
				self.aProject.push.apply(self.aProject, newItems);
			};
			
			self.aSubProject = ko.observableArray();
			self.addSubProjects = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aSubProject.removeAll();
				self.aSubProject.push.apply(self.aSubProject, newItems);
			};
			
			self.aPhase = ko.observableArray();
			self.addPhases = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aPhase.removeAll();
				self.aPhase.push.apply(self.aPhase, newItems);
			};
			
			self.aFridim1 = ko.observableArray();
			self.addFridim1s = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aFridim1.removeAll();
				self.aFridim1.push.apply(self.aFridim1, newItems);
			};
			
			self.aFridim2 = ko.observableArray();
			self.addFridim2s = function(dimensionData) {
				var newItems = ko.utils.arrayMap(dimensionData, function(item) {
					return new dimensionSelectDataModel(item.description, item.value);
				});
				self.aFridim2.removeAll();
				self.aFridim2.push.apply(self.aFridim2, newItems);
			};
			
			self.saveTimeTransaction = function(formElement) {
				upsertTimeTransactionToDB();
			}
			self.getDimensionFirstOptionName = function(nItems) {
				if (nItems === 0) {
					return getResource('app.noOptionToChoose');
				} else {
					return getResource('app.pleaseSelect');
				}
			}
			// Calendar timestamp dimensionSelectDataModel end
			
			self.createDayDutyWish = function(data, evt) {
				var $currentTarget = $((evt.currentTarget) ? evt.currentTarget : evt.srcElement);
				var $form = $currentTarget.parents('form');
				var dateDiff = 0;
				var newDutyWishObj = {}
				var success = function(data, textStatus, jqXHR) {
					if (data.success === true) {
						if (dateDiff !== 0) {
							$(ctCalendarViewModel.days()).each(function(index,obj) {
								var tmpIsoWeekday = obj.date().isoWeekday();
								if (obj.date().isBetween(newDutyWishObj.dutyWishStartDate, newDutyWishObj.dutyWishEndDate) || obj.date().isSame(newDutyWishObj.dutyWishStartDate) || obj.date().isSame(newDutyWishObj.dutyWishEndDate)) {
									if (isInArray(tmpIsoWeekday, newDutyWishObj.requestedDayIds)) {
										obj.timeStamps.push(new calendarDayItemModel(newDutyWishObj));
										obj.timeStamps.sort(_sortByItemSortOrder);
									}
								}
							});
						} else {
							updateCalendarItemsForSelectedDay(newDutyWishObj.dutyWishStartDate);
						}
						$.magnificPopup.close();
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				}
				var error = function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				}
				
				newDutyWishObj.template = 'dutyWish'
				newDutyWishObj.requestedDepartmentIds = [];
				newDutyWishObj.requestedDutyTypeIds = [];
				newDutyWishObj.requestedDayIds = [];
				newDutyWishObj.isEmployeeAvaliableOnShortNotice = $form.find('#isEmployeeAvaliableOnShortNotice').is(':checked');
				newDutyWishObj.comment = $form.find('#dutyWishComment').val();
				newDutyWishObj.commentFromEmployee = $form.find('#dutyWishComment').val();
				newDutyWishObj.date = $form.find('#dutyWishDateFrom').val();
				newDutyWishObj.fromDate = $form.find('#dutyWishDateFrom').val();
				newDutyWishObj.toDate = $form.find('#dutyWishDateTo').val();
				newDutyWishObj.dutyWishStartDate = $form.find('#dutyWishDateFrom').val();
				newDutyWishObj.dutyWishEndDate = $form.find('#dutyWishDateTo').val();
				newDutyWishObj.timeIn = '0001';
				newDutyWishObj.timeOut = '0001';
				
				// Get form checked checkboxes
				$form.find('input[name=departmentIds]:checked').map(function() {
					newDutyWishObj.requestedDepartmentIds.push(parseInt($(this).val()));
				});
				$form.find('input[name=dutyTypeIds]:checked').map(function() {
					newDutyWishObj.requestedDutyTypeIds.push(parseInt($(this).val()));
				});
				$form.find('input[name=days]:checked').map(function() {
					newDutyWishObj.requestedDayIds.push(parseInt($(this).val()));
				});
				
				dateDiff = moment(newDutyWishObj.dutyWishStartDate).diff(newDutyWishObj.dutyWishEndDate,'d');
				if (dateDiff !== 0) {
					newDutyWishObj.template = 'dutyWishPeriods'
					_api.createDutyWishPeriod_POST(
						success,
						error,
						getCookie(ACCESSTOKEN_COOKIE_NAME),
						newDutyWishObj.dutyWishStartDate, // fromDate
						newDutyWishObj.dutyWishEndDate, // toDate
						newDutyWishObj.requestedDayIds, // requestedDaysOfWeek
						newDutyWishObj.requestedDepartmentIds, // requestedDepartmentIds
						newDutyWishObj.requestedDutyTypeIds, // requestedDutyTypeIds
						newDutyWishObj.comment, // commentFromEmployee
						newDutyWishObj.isEmployeeAvaliableOnShortNotice// isEmployeeAvaliableOnShortNotice
					);
				} else {
					_api.createDutyWish_POST(
						success,
						error,
						getCookie(ACCESSTOKEN_COOKIE_NAME),
						newDutyWishObj.dutyWishStartDate,
						newDutyWishObj.requestedDepartmentIds, // requestedDepartmentIds
						newDutyWishObj.requestedDutyTypeIds, // requestedDutyTypeIds
						newDutyWishObj.comment, // commentFromEmployee
						newDutyWishObj.isEmployeeAvaliableOnShortNotice // isEmployeeAvaliableOnShortNotice
					);
				}
			}
			
			self.createAvaliableDutyRequest = function(data, evt) {
				var $currentTarget = $((evt.currentTarget) ? evt.currentTarget : evt.srcElement);
				var $form = $currentTarget.parents('form');
				var comment = $form.find('#dutyWishComment').val();
				var avaliableDuty = ctCalendarViewModel.selectedAvaliableDuty();
				var success = function(data, textStatus, jqXHR) {
					$.magnificPopup.close();
					if (data.success === true) {
						updateCalendarItemsForSelectedDay(ctCalendarViewModel.daySelected().date().format('YYYY-MM-DD'));
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				}
				var error = function(jqXHR, textStatus, errorThrown) {
					sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
				}
				_api.requestAvaliableDuty_POST(
					success,
					error,
					getCookie(ACCESSTOKEN_COOKIE_NAME),
					avaliableDuty.departmentId(),
					avaliableDuty.dutyPlanId(),
					avaliableDuty.dutyId(),
					avaliableDuty.employeeId(),
					avaliableDuty.startDate(),
					comment
				);
			}
			
			// Wish data
			self.dutyWishFormData = ko.viewmodel.fromModel(dutyWishFormData());
			
			// Events
			self.dayClickAction = function(day) {
				self.daySelected(day);
				getAccumulatedTimeByDay(day.date());
				refreshEmployeeRegistrationInformation(day.date());
			};
			
			self.removeAllCalendarDays = function() {
				self.days.removeAll();
			};
			
			self.removeAllAccumulatedTimeByMonth = function() {
				self.aAccumulatedTimeByMonth.removeAll();
			};
			self.removeAllAccumulatedTimeByDay = function() {
				self.aAccumulatedTimeByDay.removeAll();
			};
			
			self.deleteDay = function(day) {
				self.days.remove(day);
			};
			
			self.addDay = function(day) {
				self.days.push(new calendarDayModel());
			};
		};
		
		function getMomentDateTimeNow() {
			var now = moment();
			if (ctCalendarViewModel) {
				now = ctCalendarViewModel.now();
			}
			return now;
		}
		
		// Sort functions
		/*////////////////////////////////////////////////////////////*/
		_sortByTimeInASC = function(a, b) {
			return a.timeIn() < b.timeIn() ? -1 : 1;
		};

		_sortByItemSortOrder = function(a, b) {
			if (a.itemSortOrder() === b.itemSortOrder()) {
				return _sortByTimeInASC(a, b);
			} else {
				return a.itemSortOrder() < b.itemSortOrder() ? -1 : 1;
			}
			
		};
		
		_sortAccumulatedTime = function(a, b) {
			// -1 = sort a before b
			//  0 = unchanged
			//  1 = sort b before a
			var retVal = 0;
			
			// if(a.isManualAdjustment() === false && b.isManualAdjustment() === true) {
			// 	retVal = -1;
			// } else if(a.isManualAdjustment() === true && b.isManualAdjustment() === false) {
			// 	retVal = 1;
			// } else {
			// 	if (a.timeCategoryDescription().toLowerCase() < b.timeCategoryDescription().toLowerCase()) {
			// 		retVal = -1;
			// 	} else {
			// 		retVal = 1;
			// 	}
			// }
			
			if (a.timeCategoryId() < b.timeCategoryId()) {
				retVal = -1;
			} else if (a.timeCategoryId() > b.timeCategoryId()) {
				retVal = 1;
			}
			
			return  retVal;
		}
		
		// extend knockout (accepts jQuery node and remove boolean)
		/*////////////////////////////////////////////////////////////*/
		ko.unapplyBindings = function($node, remove) {
			// unbind events
			$node.find("*").each(function() {
				$(this).unbind();
			});

			// Remove KO subscriptions and references
			if (remove) {
				ko.removeNode($node[0]);
			} else {
				ko.cleanNode($node[0]);
			}
		}
		
		// click event handlers
		/*////////////////////////////////////////////////////////////*/
		$('.ct-calendar').on('click', '.ct-calendar-days .ct-calendar-column', function(e) {
			var $detailsElm = $('.ct-calendar-day-details'),
				scrollTopPos = $detailsElm.parent().position().top,
				$body = $('html, body');
			
			$('.selected').removeClass('selected');
			$(this).addClass('selected');
			
			$('.ct-calendar-month-details, .ct-calendar-balance-details').hide();
			$detailsElm.removeClass('hidden').delay(50).show();
			
			if (scrollTopPos > 100) {
				scrollTopPos -= 50;
				$body.delay(300).animate({scrollTop: scrollTopPos}, '500', 'swing', function() { 
				});
			}
		});
		
		$('.ct-calendar').on('click', '.ct-month-selector', function(e) {
			var $this = $(this);
			$this.addClass('ct-month-selector-hover');
			setTimeout(function () {
				$this.removeClass('ct-month-selector-hover');
				changeMonth($this.hasClass('ct-month-next'));
			}, 150);
		});
		
		$('.ct-calendar').on('click', 'h1', function(e) {
			$('.ct-calendar-day-details').hide()
			$('.ct-calendar-month-details, .ct-calendar-balance-details').delay(50).show()
		});
		
		$('.ct-calendar').on('change', '#ct-show-avaliable-duty', function(e) {
			$this = $(this);
			if ($this.prop('checked') && getLocalStorage('myCapitechDutyWishFilter').departmentIds.length === 1 && getLocalStorage('myCapitechDutyWishFilter').departmentIds[0] === -1)  {
				$this.prop('checked', false);
				sweetAlert({
					title: getResource('app.informationText'),
					text: getResource('dutyWishFilter.setupDepartmentDutyFilter'),
					type: 'info',
					showCancelButton: true,
					confirmButtonText: getResource('app.openFilter'),
					cancelButtonText: getResource('app.close')
				}, function(isConfirm) {
					if(isConfirm) {
						window.location.href = 'profile.htm?v={gulp-my-capitech-version}#department-duty-filter';
					}
				});
			}
		});
		
		$('.ct-btn-select-all').click(function(evt) {
			evt.preventDefault();
			var $this = $(this);
			var markCheckbox = true;
			if ($this.val() == 'false') {
				markCheckbox = false;
			}
			$this.parents('.ct-checkbox-group-wrapper').find('.ct-checkbox-group input:checkbox').each(function(index, obj) {
				$(obj).prop('checked', markCheckbox);
			});
		});
		
		// $('#ct-create-dutywish').on('change', '#dutyWishType', function(e) {
		// 	var $this = $(this);
		// 	var $component = $('#ct-create-dutywish');
		// 	var selectedValue = $this.val();
		//
		// 	if (selectedValue == 'day') {
		// 		$('.ct-checkbox-days').hide(0);
		// 		$('.ct-checkbox-group-wrapper').removeClass('col-md-4').addClass('col-md-6');
		// 	} else {
		// 		$('.ct-checkbox-group-wrapper').removeClass('col-md-6').addClass('col-md-4');
		// 		$('.ct-checkbox-days').show(0);
		// 	}
		// });
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
	};
}(jQuery));